import Media from './../mediaDetect.js'; //Детектор медиа

let Popup = {
    initInlinePopup: function(){
        $('.js-popup-link').magnificPopup({
            type:'inline',
            midClick: true,
            showCloseBtn: false 
        });
    },
    initIframePopup: function(){
        $('.js-popup-video').magnificPopup({
            type:'iframe',
            midClick: true,
            showCloseBtn: false 
        });
    },
    openInlinePopupWithDataAttr: function(currBtn){
        var currContent = currBtn.closest('[data-popup]').find('[data-content-popup]');
        $.magnificPopup.open({
            items: {
                src: currContent
            },
            type: 'inline',
            midClick: true,
            showCloseBtn: false,
            callbacks: {
                beforeOpen: function() {
                    var currZoom = currContent.find('.zoom');
                    
                    if(currZoom.length){
                       Popup.zoom(currZoom);
                    }
                }
            }
        });
    },
    closePopup: function(){
        $('body').on('click', '.js-close-popup', function(e) {
            e.preventDefault();
            $.magnificPopup.close();
        });
    },
    zoom: function(zoom){
        zoom.panzoom({
            minScale: 1,
            maxScale: 5
        });
    }
}

$(document).ready(function ($) {

    Popup.initInlinePopup();
    Popup.initIframePopup();
    Popup.closePopup();
    Popup.zoom($(".zoom"));

    $('body').on('click', '[data-btn-popup]', function(){
        var _this = $(this),
            valBtn = $(this).data('btn-popup');

        Popup.openInlinePopupWithDataAttr(_this);
    });
});


// WEBPACK FOOTER //
// ./components/popup.js